export default __webpack_public_path__ + "static/media/dec_con_res.737f0262.PNG";